module.exports = __webpack_public_path__ + "f02d3390257a40ebb0db8db0b8c3e4dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emojis/score-2.svg
// module id = 162
// module chunks = 0